import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import "./PD.css";

const ProjectDetails = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    axios.get('https://aspwppl-backend.vercel.app/projects')
      .then((res) => {
        const selected = res.data.find(item => item._id === id);
        setProject(selected);
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  }, [id]);

  if (!project) return <p className="loading-text">Loading...</p>;

  return (
    <div className='project-details-pd'>
      <h2 className="pd-title">{project.projectsname}</h2>
      <p className="pd-description">{project.details}</p>

      <div className="pd-info">
        <p><strong>📍 Location:</strong> {project.location}</p>
        <p><strong>🏢 Client:</strong> {project.client}</p>
        <p><strong>🗺️ State:</strong> {project.state}</p>
        <p><strong>🌐 Coordinates:</strong> {project.latitude}, {project.longitude}</p>
      </div>

      {project.keypoints?.length > 0 && (
        <div className="pd-keypoints">
          <h4>Key Highlights</h4>
          <ul>
            {project.keypoints.map((k, i) => (
              <li key={i}>✅ {k.points}</li>
            ))}
          </ul>
        </div>
      )}

      {project.stats?.length > 0 && (
        <div className="pd-stats">
          {project.stats.map((stat, i) => (
            <div key={i} className="pd-stat-item">
              <i className={stat.icon}></i>
              <div>
                <p className="stat-label">{stat.points}</p>
                <p className="stat-value">{stat.number}</p>
              </div>
            </div>
          ))}
        </div>
      )}

<div className="pd-images">
  {project.photo?.map((img, i) => (
    <a
      key={i}
      href={img.url}
      target="_blank"
      rel="noopener noreferrer"
      className="pd-image-link"
    >
      <img src={img.url} alt={`project-${i}`} className="pd-image" />
    </a>
  ))}
</div>

    </div>
  );
};

export default ProjectDetails;
